(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["installment-popups"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('installment-handle')) {
        customElements.define(
            'installment-handle',
            class installmentHandle extends HTMLElement {
                constructor() {
                    super();
                    
                    this.targetElement = null;
                    this.targetElementEventType = null;
                    this.installmentPopup = this.closest(".installment-popup");
                    this.close = this.installmentPopup.querySelector("[data-close]");

                    this.installmentBroadcast = new ecomBroadcast("installmentHandle");

                    this.addEventListener("click", this.confirmInstallmentRemove.bind(this));
                    document.addEventListener("installment_popup:add-normal-items", this.openPopup.bind(this));
                }
                
                openPopup (event){
                    this.installmentPopup.classList.remove("hidden");
                    this.targetElement = event.detail.targetElement;
                    this.targetElementEventType = event.detail.eventType;
                }

                closePopup(){
                    this.installmentPopup.classList.add("hidden");

                    // enable buttons
                    this.close.disabled = false
                    this.disabled = false;
                    this.classList.remove("loading");
                    this.querySelector(".loading__spinner").classList.add("hidden");
                }

                async confirmInstallmentRemove(event) {
                    event.preventDefault();
                    
                    // disable buttons
                    this.close.disabled = true
                    this.disabled = true;
                    this.classList.add("loading");
                    this.querySelector(".loading__spinner").classList.remove("hidden");

                    const cart = await this.getCart();
                    const installmentProducts = this.getInstallmentProducts(cart);
                    const removeItems = this.createRemoveItems(installmentProducts);
                    const addToCartItems = this.createAddToCart(installmentProducts);

                    //send cart update
                    await this.updateCart(removeItems);
                    await new Promise(resolve => setTimeout(resolve, 1200));
                    await this.addToCart(addToCartItems);

                    //fetch cart again and update the cart localstorage
                    await this.updateCartLocalStorage();

                    if(this.targetElement) {
                        if(this.targetElementEventType == "change") {
                            this.targetElement.dispatchEvent(new Event("change", {bubbles: true}));
                        }
                        if(this.targetElementEventType == "click") {
                            this.targetElement.click();
                        }
                    }

                    await new Promise(resolve => setTimeout(resolve, 1200));
                    this.installmentBroadcast.sendMessage({ type: "ecom_cart_items:update", runFunction: true }); //broadcast the cart chagne for update the other tabs
                    this.closePopup();
                }
                
                async getCart() {
                    const cartReq = await fetch("/cart?view=ajax");
                    const cart = await cartReq.json();
                    return cart;
                }
                
                async updateCartLocalStorage() {
                    const cart = await this.getCart();
                    window.localStorage.setItem('ecom_cart_items', JSON.stringify(cart));
                    document.dispatchEvent(new CustomEvent("ecom_cart_items:update", {bubbles: true}));
                    await new Promise(resolve => setTimeout(resolve, 100));
                }

                //remove products from the cart that inserted as installment
                async updateCart(updates) {
                    const _fetch = await fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": 'application/json'
                        },
                        body: JSON.stringify({updates}) 
                    });
                    const resp = await _fetch.json();
                    return resp;
                }

                async addToCart(items) {
                    const _fetch = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": 'application/json'
                        },
                        body: JSON.stringify({"items":items}) 
                    });
                    const resp = await _fetch.json();
                    return resp;
                }

                getInstallmentProducts(cart) {
                    return cart.items.filter(item => item.current_variant_properties.flat().includes("_installment"))
                }
                
                createRemoveItems(needToRemove) {
                    const updates = needToRemove.reduce((acc, item) => {
                        acc[item.current_line_item_key] = 0
                        return acc;
                    }, {});

                    return  updates;
                } 

                createAddToCart(needToRemove){
                    return needToRemove.map(item=>({ "id" : item.current_variant, "quantity": item.current_quantity}));
                }
            }
        );
    }

    if (!customElements.get('installment-convert-to-installment')) {
        customElements.define(
            'installment-convert-to-installment',
            class installmentConvertToInstallment extends HTMLElement {
                constructor() {
                    super();
                    
                    this.targetElement = null;
                    this.targetElementEventType = null;
                    this.installmentPopup = this.closest(".installment-popup");
                    this.close = this.installmentPopup.querySelector("[data-close]");

                    this.installmentBroadcast = new ecomBroadcast("installmentHandle");

                    this.addEventListener("click", this.confirmConvertToInstallment.bind(this));
                    document.addEventListener("installment_popup:convert-to-installment", this.openPopup.bind(this));
                }
                
                openPopup (event){
                    this.installmentPopup.classList.remove("hidden");
                    this.targetElement = event.detail.targetElement;
                    this.targetElementEventType = event.detail.eventType;
                }

                closePopup(){
                    this.installmentPopup.classList.add("hidden");
                    
                    // enable buttons
                    this.close.disabled = false;
                    this.disabled = false;
                    this.classList.remove("loading");
                    this.querySelector(".loading__spinner").classList.add("hidden");
                }

                async confirmConvertToInstallment(event) {
                    event.preventDefault();
                    
                    // disable buttons
                    this.close.disabled = true
                    this.disabled = true;
                    this.classList.add("loading");
                    this.querySelector(".loading__spinner").classList.remove("hidden");

                    const cart = await this.getCart();

                    const installmentProducts = this.getInstallmentProducts(cart);
                    const removeItems = this.createRemoveItems(installmentProducts);
                    const addToCartItems = this.createAddToCart(installmentProducts);

                    //send cart update
                    await this.updateCart(removeItems);
                    await new Promise(resolve => setTimeout(resolve, 1200));
                    await this.addToCart(addToCartItems);
                    
                    //fetch cart again and update the cart localstorage
                    await new Promise(resolve => setTimeout(resolve, 400));
                    await this.updateCartLocalStorage();

                    if(this.targetElement) {
                        if(this.targetElementEventType == "change") {
                            this.targetElement.dispatchEvent(new Event("change", {bubbles: true}));
                        }
                        if(this.targetElementEventType == "click") {
                            this.targetElement.click();
                        }
                    }

                    await new Promise(resolve => setTimeout(resolve, 1200));
                    this.installmentBroadcast.sendMessage({ type: "ecom_cart_items:update", runFunction: true }); //broadcast the cart chagne for update the other tabs
                    this.closePopup();
                }
                
                async getCart() {
                    const cartReq = await fetch("/cart?view=ajax");
                    const cart = await cartReq.json();
                    return cart;
                }
                
                async updateCartLocalStorage() {
                    const cart = await this.getCart();
                    window.localStorage.setItem('ecom_cart_items', JSON.stringify(cart));
                    document.dispatchEvent(new CustomEvent("ecom_cart_items:update", {bubbles: true}));
                    await new Promise(resolve => setTimeout(resolve, 500));
                }

                //remove products from the cart that inserted as installment
                async updateCart(updates) {
                    const _fetch = await fetch("/cart/update.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": 'application/json'
                        },
                        body: JSON.stringify({updates}) 
                    });
                    const resp = await _fetch.json();
                    return resp;
                }

                async addToCart(items) {
                    const _fetch = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: {
                            "Content-Type": 'application/json'
                        },
                        body: JSON.stringify({"items":items}) 
                    });
                    const resp = await _fetch.json();
                    return resp;
                }

                getInstallmentProducts(cart) {
                    return cart.items.filter(item => item.current_variant_product_tags.includes("ipg_mintpay"))
                }
                
                createRemoveItems(needToRemove) {
                    const updates = needToRemove.reduce((acc, item) => {
                        acc[item.current_line_item_key] = 0
                        return acc;
                    }, {});

                    return  updates;
                } 

                createAddToCart(needToRemove){
                    return needToRemove.map(item=>({ "id" : item.current_variant, "quantity": item.current_quantity, "properties": { "_installment": "mintpay" }}));
                }
            }
        );
    }
  } catch(e) { console.error(e); }
})();

})();
